// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1Vlbk","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3liCn","obliqueLine":"membershipbadge_obliqueLine__3hMZs"};